// extracted by mini-css-extract-plugin
export default {"container":"ERlP6Bx"};